import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { fromList } from '@core/services';

import { SystemActions } from '@system/state';

@Injectable({
  providedIn: 'root',
})
export class SystemService {
  systemDefaultList$ = this.store.select(fromList.selectSystemDefaultList);

  systemDefaults: Record<string, string> = null;
  systemDefaults$ = new BehaviorSubject<Record<string, string>>(null);

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private store: Store, private translocoService: TranslocoService) {
    this.systemDefaultList$.pipe(filter((list) => !!list)).subscribe((list) => {
      const defaults: Record<string, string> = {};

      for (const row of list.data) {
        defaults[row.key] = row.value as string;
      }

      this.systemDefaults = defaults;
      this.systemDefaults$.next(defaults);
    });
  }

  requestLists() {
    this.store.dispatch(SystemActions.RequestLists());
  }
}
